import { LAYOUT_TYPE, LayoutType } from '@sbercloud/uikit-product-utils';

import { CssBreakPoints, CssBreakPointsKeys, Predicate } from '@/types/common';
import { complement, equals, isNil } from '@/utils/common';

export const isLargeThan: Predicate<[LayoutType, LayoutType | null]> = (target, layoutType) => {
  const BREAKPOINT_ORDER: LayoutType[] = ['mobile', 'tablet', 'desktopSmall', 'desktop'];

  if (isNil(layoutType)) return false;

  const getBreakPointsIndexOf = (of: LayoutType) => BREAKPOINT_ORDER.indexOf(of);

  return getBreakPointsIndexOf(layoutType) > getBreakPointsIndexOf(target);
};

export const isLoverThan = complement(isLargeThan);

export const cssBreakPointToLayoutType = (breakpoint: CssBreakPointsKeys | null): LayoutType => {
  if (isNil(breakpoint)) return LAYOUT_TYPE.Mobile;
  const breakpointIs = equals(breakpoint);
  if (breakpointIs('smallDesktop')) return LAYOUT_TYPE.DesktopSmall;
  if (breakpointIs('large')) return LAYOUT_TYPE.Desktop;
  return breakpoint as LayoutType;
};

export const findBreakPointName = (breakPoints: CssBreakPoints) => {
  const entries = Object.entries(breakPoints) as [CssBreakPointsKeys, string][];

  return cssBreakPointToLayoutType(
    entries.reduce<CssBreakPointsKeys | null>((acc, [key, mediaQuery]) => {
      if (acc) return acc;
      if (window.matchMedia(mediaQuery).matches) return key;
      return acc;
    }, null),
  );
};
